var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneOnOneSessionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99967 1.83301C4.25301 1.83301 2.83301 3.25301 2.83301 4.99967C2.83301 6.71301 4.17301 8.09967 5.91967 8.15967C5.97301 8.15301 6.02634 8.15301 6.06634 8.15967C6.07968 8.15967 6.08634 8.15967 6.09967 8.15967C6.10634 8.15967 6.10634 8.15967 6.11301 8.15967C7.81967 8.09967 9.15968 6.71301 9.16634 4.99967C9.16634 3.25301 7.74634 1.83301 5.99967 1.83301Z",
    fill: "#6B60E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38664 9.93293C7.52664 8.69293 4.49331 8.69293 2.61997 9.93293C1.77331 10.4996 1.30664 11.2663 1.30664 12.0863C1.30664 12.9063 1.77331 13.6663 2.61331 14.2263C3.54664 14.8529 4.77331 15.1663 5.99997 15.1663C7.22664 15.1663 8.45331 14.8529 9.38664 14.2263C10.2266 13.6596 10.6933 12.8996 10.6933 12.0729C10.6866 11.2529 10.2266 10.4929 9.38664 9.93293Z",
    fill: "#6B60E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3263 5.39307C13.4329 6.68641 12.5129 7.81974 11.2396 7.97307C11.2329 7.97307 11.2329 7.97307 11.2263 7.97307H11.2062C11.1662 7.97307 11.1262 7.97307 11.0929 7.98641C10.4462 8.01974 9.85292 7.81307 9.40625 7.43307C10.0929 6.81974 10.4863 5.89974 10.4062 4.89974C10.3596 4.35974 10.1729 3.86641 9.89292 3.44641C10.1463 3.31974 10.4396 3.23974 10.7396 3.21307C12.0463 3.09974 13.2129 4.07307 13.3263 5.39307Z",
    fill: "#6B60E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6605 11.5599C14.6071 12.2066 14.1938 12.7666 13.5005 13.1466C12.8338 13.5133 11.9938 13.6866 11.1605 13.6666C11.6405 13.2333 11.9205 12.6933 11.9738 12.1199C12.0405 11.2933 11.6471 10.4999 10.8605 9.86661C10.4138 9.51327 9.89382 9.23327 9.32715 9.02661C10.8005 8.59994 12.6538 8.88661 13.7938 9.80661C14.4071 10.2999 14.7205 10.9199 14.6605 11.5599Z",
    fill: "#6B60E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneOnOneSessionIcon);
export default __webpack_public_path__ + "static/media/one-on-one-session-icon.e400055ac455bfe8dd5490e4640fea8c.svg";
export { ForwardRef as ReactComponent };